import { tv } from "@opensea/ui-kit"

export const itemCardActionVariants = tv({
  slots: {
    section: "",
    tokenPrice: "gap-1.5 font-normal",
  },
  variants: {
    itemView: {
      grid: {},
      gridCompact: {
        section: "flex-col items-start justify-center first:items-start",
        tokenPrice: "-mt-px text-xs",
      },
      mosaic: {},
      table: {},
      tableCompact: {},
    },
  },
})
